<div class="flex-1 min-h-0 overflow-hidden flex" *transloco="let t;">
  <div class="flex flex-col h-full w-96">
    <div class="text-lg font-bold px-2 py-4 border border-b-0">
      {{t('backoffice.user.artworks.uploaded')}}
    </div>
    <div class="flex flex-col overflow-auto h-full border-r w-full">
      @for (artwork of artworks.value()?.data; track artwork.id) {
        <a [routerLink]="['./',artwork.id]" class="w-full flex gap-4 p-4 border border-r-0 border-b-0 border-gray-400">
          <div class="min-w-20">
            <img class="w-20 h-20" [src]="artwork.mainAttachment?.url">
          </div>
          <div class="flex flex-col justify-between w-full">
            <div class="font-thin flex justify-between w-full gap-4">
              <div class="w-4/5 ">
                {{artwork.name}}
              </div>
              <div class="w-1/5 flex justify-start items-start">
                <div class="flex items-center gap-2">
                  <div [className]="'artwork-enum artwork-enum-' + artwork.status"></div>
                  <div>
                    {{t('ARTWORK_ENUM.' + artwork.status)}}
                  </div>
                </div>

              </div>
            </div>
            <div>
              <div>Type</div>
              <div class="capitalize font-thin">{{artwork.type.toLowerCase()}}</div>
            </div>
          </div>
        </a>
      }
    </div>
  </div>
  <div class="flex-1 min-h-0 overflow-auto">
    <router-outlet></router-outlet>
  </div>
</div>
